<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>{{
        options.item.action == 'add'
          ? $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.pageHeaderAdd')
          : $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.pageHeaderModify')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-row class="ml-4 mr-4 data-section">
      <v-col cols="12" lg="4" class="pa-0">
        <v-row no-gutters style="height: 100%;">
          <v-col cols="12" lg="10" class="code-table-grid">
            <v-row no-gutters class="mb-2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="code-group-label">{{
                $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.sqlGroupName')
              }}</span>
            </v-row>
            <v-row no-gutters class="mb-2">
              <v-text-field
                ref="sqlGroupName"
                v-model="sqlGroupName"
                class="data-table-filter-text-field custom-selectbox find-table-code"
                height="40"
                hide-details
                dense
                solo
                outlined
              ></v-text-field>
            </v-row>
            <v-row v-if="sqlGroupData.length > 0" no-gutters class="mb-0">
              <v-col cols="2" class="pa-0">
                <v-icon
                  class="ma-2"
                  small
                  @click="moveUpQuery"
                  :disabled="selectItemQueryList.length === 0 || selectedItemIndex === 0"
                  color="#5FCBFA"
                  >fas fa-caret-up</v-icon
                >
                <v-icon
                  class="ma-0"
                  small
                  @click="moveDownQuery"
                  :disabled="
                    selectItemQueryList.length === 0 ||
                      selectedItemIndex === this.sqlGroupData.length - 1
                  "
                  color="#5FCBFA"
                  >fas fa-caret-down</v-icon
                >
              </v-col>
              <v-col v-if="sqlGroupData[0].sql_cnt_tp" cols="10" class="pa-0">
                <div class="mt-1">{{ sqlGroupData[0].sql_cnt_tp }}</div>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-2 vuebar-element db-broker-left-panel">
              <v-col cols="9">
                <v-list nav dense class="code-group-list pt-0" :flat="true">
                  <v-list-item-group v-model="selectedItemIndex" color="primary">
                    <v-list-item
                      v-for="(item, index) in sqlGroupData"
                      :key="index"
                      @click="selectItemQuery(item)"
                      class="mb-0"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="btn-tooltip mr-0">
                            <v-list-item-icon> {{ index + 1 }}. </v-list-item-icon>
                          </div>
                        </template>
                        <span
                          v-html="$t('lbl.dataSource.sqlGroup.addSqlGroupDialog.tooltipQuerySeq')"
                        ></span>
                      </v-tooltip>
                      <v-list-item-content>
                        <a class="group-code-link">{{ item.sql_cnt_nm }}</a>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col cols="3">
                <v-list nav dense class="code-group-list pt-0" :flat="true" width="55px">
                  <v-list-item-group color="primary">
                    <v-list-item v-for="(item, index) in sqlGroupData" :key="index" class="mb-0">
                      <v-list-item-icon @click.stop="confirmDeleteItem(item)">
                        <v-icon x-small class="pa-2">fas fa-times</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content> </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" lg="2" class="pt-0 pb-0 btn-add-code-row">
            <v-btn
              class="btn btn-top btn-search btn-add-code"
              color="primary"
              @click="addSQLGroup"
              :disabled="isBtnActive"
            >
              <v-icon :size="20" class="mr-2 ml-2">fas fa-angle-double-left</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="8" class="code-table-grid">
        <v-row class="ma-0">
          <!-- [S]  second table-->
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0">
              <v-col cols="3" class="pa-0 pr-2">
                <v-text-field
                  v-model="searchBy.sql_cnt_nm"
                  :placeholder="
                    $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.conditionSearch.queryName')
                  "
                  @keyup.enter="getSQLGroupQueryInfoList"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  heigth="30"
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="3" class="pa-0 pr-2">
                <v-select
                  v-model="searchBy.sql_cnt_tp"
                  :items="types"
                  :menu-props="{ offsetY: true }"
                  label="Type"
                  @change="getSQLGroupQueryInfoList"
                  class="data-table-filter-text-field search-button-data-analysis-table label-peer-text1"
                  hide-details
                  dense
                ></v-select>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-text-field
                  v-model="searchBy.sql_cnt"
                  :placeholder="
                    $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.conditionSearch.queryText')
                  "
                  @keyup.enter="getSQLGroupQueryInfoList"
                  class="data-table-filter-text-field search-button-data-analysis-table"
                  heigth="30"
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col cols="12" class="pa-0 pt-2">
                <v-data-table
                  :search="searchCodeName"
                  :headers="headerSQLGroup"
                  :items="sqlGroupQueryInfoList"
                  :items-per-page="-1"
                  :hide-default-footer="true"
                  :disable-sort="false"
                  class="map-list-table code-list-data-table db-broker-data-table pb-0"
                  fixed-header
                >
                  <template v-slot:header.checkbox>
                    <v-checkbox
                      v-model="checkedAll"
                      @change="selectAllChange"
                      class="select-checkbox-layout-table align-center justify-center"
                      color="#dbd7db"
                      dense
                      hide-details
                    ></v-checkbox>
                  </template>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="index"
                        :class="[
                          selectedRowLinked == item.sql_cnt_nm ||
                          (selectedRowLinked == '' && index == 0)
                            ? 'selected_row'
                            : '',
                        ]"
                      >
                        <td class="checkbox-col">
                          <v-checkbox
                            v-model="item.checked"
                            @click.native.stop
                            @click.native="selectItemChange($event, item)"
                            class="select-checkbox-layout-table align-center justify-center"
                            color="#dbd7db"
                            dense
                            hide-details
                            :disabled="item.disabled"
                          ></v-checkbox>
                        </td>
                        <td class="code-grp-col no-wrap">{{ item.sql_cnt_nm }}</td>
                        <td class="code-grp-col no-wrap custom-type-db">{{ item.sql_cnt_tp }}</td>
                        <td class="code-grp-col no-wrap">{{ item.sql_cnt }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
          <!-- [E]  second table-->
        </v-row>
      </v-col>
    </v-row>
    <v-row class="no-gutters btn-code-section">
      <v-col cols="12" lg="4" class="pa-0 text-right">
        <v-row no-gutters>
          <v-col cols="12" lg="10">
            <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="saveSQLGroupName">
              <!-- <v-icon x-small class="mr-2">fas fa-save</v-icon> -->
              {{ $t('btn.common.save') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="8" class="pa-0 text-right pr-4">
        <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
          <!-- <v-icon x-small class="mr-2">fas fa-times</v-icon> -->
          {{ $t('btn.common.close') }}
        </v-btn>
      </v-col>
    </v-row>
    <dialogWindow
      ref="validateAddSQLGroup"
      :detail="$t('msg.dataSource.sqlGroup.warningAddSQLGroup')"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      :detail="$t('msg.common.deleteConfirm')"
      :dataValue="deleteData"
      :showCancel="true"
      @select-ok="deleteSQLGroup($event)"
      color="information"
      size="max"
      title="confirmDialog"
    ></dialogWindow>
    <dialogWindow
      ref="warningDbType"
      :detail="$t('msg.dataSource.sqlGroup.warningDbType')"
      :showCancel="false"
      color="validation"
      size="max"
      title="warning"
    ></dialogWindow>
    <dialogWindow
      ref="warningSaveSQLGroup"
      :detail="$t('msg.common.require', ['SQL Group Name'])"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
      @select-ok="focusSQLGroupName($event)"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  name: 'add-code-group-dialog',
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    selectFile: String,
    types: Array,
  },
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  data() {
    return {
      sqlGroupName: '',
      sqlGroupData: [],
      selectItemQueryList: [],
      selectedItemIndex: '',
      deleteData: '',
      selectMasterRows: [],
      sqlGroupQueryInfoList: [],
      checkedAll: false,
      searchCodeName: '',
      isDisabledAll: false,
      selectedRowLinked: '',
      sqlGroupDetailList: [],
      searchBy: {
        sql_cnt_nm: '',
        sql_cnt_tp: '',
        sql_cnt: '',
      },
      addDataItems: {
        sql_grp_nm: '',
        sql_grp_id: '',
        sqlGroupQueryInfo: [],
      },
      headerSQLGroup: [
        { value: 'checkbox', text: '', width: '60px', class: 'checkbox-col' },
        {
          text: this.$t('tbl.datasource.addSqlGroupDialog.queryName'),
          value: 'sql_cnt_nm',
          width: '150px',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.addSqlGroupDialog.type'),
          value: 'sql_cnt_tp',
          width: '50px',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.addSqlGroupDialog.queryText'),
          value: 'sql_cnt',
          width: '250px',
          align: 'center',
        },
      ],
    };
  },
  computed: {
    isBtnActive() {
      return this.selectMasterRows.length > 0 ? false : true;
    },
  },
  watch: {
    sqlGroupData() {
      if (this.sqlGroupData.length > 0) {
        let sql_cnt_tp = this.sqlGroupData[0].sql_cnt_tp;
        let sqlGroupQueryInfoList = this.sqlGroupQueryInfoList.filter(
          (item) => item.sql_cnt_tp === sql_cnt_tp
        );
        this.isDisabledAll =
          sqlGroupQueryInfoList.length === this.sqlGroupData.length ? true : false;
      }
    },
  },
  methods: {
    saveSQLGroupName() {
      if (this.sqlGroupData.length < 1) {
        this.$refs.validateAddSQLGroup.dialog = true;
        return;
      } else if (this.sqlGroupName.trim() == '') {
        this.$refs.warningSaveSQLGroup.dialog = true;
      } else {
        this.addDataItems.sql_grp_nm = this.sqlGroupName;
        this.addDataItems.sql_grp_type = 'S';
        this.sqlGroupData.map((item, index) => {
          this.addDataItems.sqlGroupQueryInfo[index] = {
            sql_cnt_id: item.sql_cnt_id,
            sql_cnt: item.sql_cnt,
            seq: index + 1,
          };
        });
        if (this.options.item.action == 'add') {
          // console.log("----------------Add SQL Group----------", this.addDataItems)
          this.$store.dispatch('addSQLGroup', this.addDataItems).then(() => {
            this.refreshDialog({});
          });
        } else {
          this.addDataItems.sql_grp_id = this.options.item.selectedRow.sql_grp_id;
          // console.log("----------------Modify SQL Group----------", this.addDataItems)
          this.$store.dispatch('modifySQLGroup', this.addDataItems).then(() => {
            this.refreshDialog({});
          });
        }
      }
      EventBus.$emit('getGroupList');
    },
    selectItemChange(event, item) {
      let checked = item.checked;
      if (checked == true) {
        this.selectMasterRows.push(item);
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, 'sql_cnt_id');
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
      // console.log("checked", this.selectMasterRows)
    },
    validateDbNameAndType(itemChecked, selectMasterRows) {
      // console.log("----------validateDbNameAndType------",itemChecked, selectMasterRows)
      let isValidate = false;
      selectMasterRows.map((item) => {
        if (itemChecked.sql_cnt_tp !== item.sql_cnt_tp) {
          this.$refs.warningDbType.dialog = true;
          isValidate = true;
          itemChecked.checked = false;
          return;
        }
      });
      if (!isValidate) {
        this.selectMasterRows.push(itemChecked);
      }
    },
    selectAllChange(value) {
      let sqlContnets = [];
      this.checkedAll = value;
      this.sqlGroupQueryInfoList
        .filter((obj) => obj.disabled != true)
        .map((obj) => {
          obj.checked = value;
          value ? sqlContnets.push(obj) : null;
        });
      this.selectMasterRows = sqlContnets;
    },
    getConvertQueryType(itemSQLGroup) {
      let convertType = '';
      let type = this.types.filter(
        (itemType) => itemType.value.toLowerCase() === itemSQLGroup.sql_cnt_tp
      );
      if (type[0]) {
        convertType = type[0].text;
      }
      return convertType;
    },
    reloadDbBrokerListDisabled() {
      let sqlGroupData = JSON.parse(
        JSON.stringify(this.sqlGroupData.concat(this.selectMasterRows))
      );
      sqlGroupData.map((item) => {
        let indexDisabled = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
        if (indexDisabled != null) {
          this.sqlGroupQueryInfoList[indexDisabled].disabled = true;
          this.sqlGroupQueryInfoList[indexDisabled].checked = true;
          this.sqlGroupQueryInfoList.splice(
            indexDisabled,
            1,
            this.sqlGroupQueryInfoList[indexDisabled]
          );
        }
      });
    },
    getSQLGroupQueryInfoList() {
      this.$store.dispatch('getSQLGroupQueryInfoList', this.searchBy).then(() => {
        this.sqlGroupQueryInfoList = this.$store.getters.sqlGroupQueryInfoList;
        // console.log("-------------Before getSQLGroupQueryInfoList-----------------", this.sqlGroupQueryInfoList);
        this.sqlGroupQueryInfoList.map((itemSQLGroup, index) => {
          let queryType = this.getConvertQueryType(itemSQLGroup);
          this.sqlGroupQueryInfoList[index].sql_cnt_tp = queryType;
        });
        // console.log("-------------After getSQLGroupQueryInfoList-----------------", this.sqlGroupQueryInfoList);
        this.reloadDbBrokerListDisabled();
      });
    },
    addSQLGroup() {
      if (this.sqlGroupData.length < 1) {
        let element;
        for (let index = 0; index < this.selectMasterRows.length; index++) {
          element = this.selectMasterRows[index];
          this.sqlGroupData.push(element);
        }
      } else {
        this.sqlGroupData = this.sqlGroupData.concat(this.selectMasterRows);
      }
      // console.log("sql group data", this.sqlGroupData)
      this.sqlGroupData.map((item) => {
        let index = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
        if (index != null) {
          this.$nextTick(() => {
            this.sqlGroupQueryInfoList[index].disabled = true;
            this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
          });
        }
      });
      this.checkedAll = false;
      this.selectMasterRows = [];
    },
    confirmDeleteItem(item) {
      this.deleteData = item;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    deleteSQLGroup(item) {
      let indexDisabled = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
      if (indexDisabled != null) {
        this.sqlGroupQueryInfoList[indexDisabled].disabled = false;
        this.sqlGroupQueryInfoList[indexDisabled].checked = false;
        this.sqlGroupQueryInfoList.splice(
          indexDisabled,
          1,
          this.sqlGroupQueryInfoList[indexDisabled]
        );
      }

      let index = this.findIndexItem(item, this.sqlGroupData, 'sql_cnt_id');
      if (index != null) {
        this.sqlGroupData.splice(index, 1);
      }
    },
    selectItemQuery(item) {
      if (this.selectItemQueryList.length > 0) {
        this.selectItemQueryList[0].sql_cnt_id !== item.sql_cnt_id
          ? this.selectItemQueryList.splice(0, 1, item)
          : this.selectItemQueryList.pop();
      } else {
        this.selectItemQueryList.push(item);
      }
      // console.log("---------selectItemQuery--------", item, this.selectItemQueryList)
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    swap(sqlGroupData, index1, index2) {
      var temp = sqlGroupData[index2];
      sqlGroupData.splice(index2, 1, sqlGroupData[index1]);
      sqlGroupData.splice(index1, 1, temp);
    },
    moveUpQuery() {
      let selectedItem = this.selectItemQueryList[0];
      if (selectedItem) {
        let index = this.findIndexItem(selectedItem, this.sqlGroupData, 'sql_cnt_id');
        if (index != null && index > 0) {
          this.swap(this.sqlGroupData, index, index - 1);
          this.selectedItemIndex = index - 1;
        }
      }
      // console.log("---------------MoveUpQuery---------", this.sqlGroupData);
    },
    moveDownQuery() {
      let selectedItem = this.selectItemQueryList[0];
      let sqlGroupDataLength = this.sqlGroupData.length;
      if (selectedItem) {
        let index = this.findIndexItem(selectedItem, this.sqlGroupData, 'sql_cnt_id');
        if (index != null && index < sqlGroupDataLength - 1) {
          this.swap(this.sqlGroupData, index, index + 1);
          this.selectedItemIndex = index + 1;
        }
      }
      // console.log("---------------MoveDownQuery---------", this.sqlGroupData);
    },
    getSQLGroupDetail(sqlGroupId) {
      this.$store.dispatch('getSQLGroupDetail', { sqlGroupId: sqlGroupId }).then(() => {
        this.sqlGroupDetailList = this.$store.getters.sqlGroupDetailList;
        this.sqlGroupData = this.sqlGroupDetailList;
        this.sqlGroupData.map((item, index) => {
          this.sqlGroupData[index].sql_cnt_tp = this.getConvertQueryType(item);
          let indexDisabled = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
          if (indexDisabled != null) {
            this.sqlGroupQueryInfoList[indexDisabled].disabled = true;
            this.sqlGroupQueryInfoList[indexDisabled].checked = true;
            this.sqlGroupQueryInfoList.splice(
              indexDisabled,
              1,
              this.sqlGroupQueryInfoList[indexDisabled]
            );
          }
        });
        // console.log("-------------getSQLGroupDetail-----------------", this.sqlGroupDetailList);
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      // this.closeDialog(dialog);
      EventBus.$emit('remove-dialog-add', dialog);
    },
    refreshDialog(dialog) {
      dialog.id = this.id;
      EventBus.$emit('refeshListSQLManage');
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    focusSQLGroupName() {
      this.setFocus();
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.sqlGroupName.focus();
      }, 300);
    },
  },
  created() {
    this.getSQLGroupQueryInfoList();
    this.setFocus();
    if (this.options.item.action == 'modify') {
      this.getSQLGroupDetail(this.options.item.selectedRow.sql_grp_id);
      this.sqlGroupName = this.options.item.selectedRow.sql_grp_nm;
    }
  },
};
</script>
<style>
.db-adapter-builder .maplist-layout-dialog .v-input.label-peer-text1 {
  margin-top: 0px;
}
.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text1
  .v-input__control
  .v-input__slot
  .v-select__slot {
  height: 28px !important;
}
.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text1
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-label--active {
  top: 26px !important;
  left: 13px !important;
  color: gray !important;
}

.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text1
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-select__selections {
  margin-left: 60px !important;
  padding-top: 0px !important;
}

.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text1
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-input__append-inner {
  margin-top: 1px !important;
}
</style>
